import { render, staticRenderFns } from "./TitleButton.vue?vue&type=template&id=022186e4"
import script from "./TitleButton.vue?vue&type=script&lang=js"
export * from "./TitleButton.vue?vue&type=script&lang=js"
import style0 from "./TitleButton.vue?vue&type=style&index=0&id=022186e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports